$(function() {

  if (('IntersectionObserver' in window)) {


    /*
     * VARIABLES
     ***********************************/

    var blanks = [];
    var markers = document.querySelectorAll('[id*="marker-"]');
    var paths = [];
    var path_lengths = [];
    var observer;
    var scroll_direction = 1;
    var scroll_tmp = window.scrollY;
    var is_updating = false;


    /*
     * FUNCTIONS
     ***********************************/
    
    // Generates the threshold array for IntersectionObserver (ex: [0, 0.1, 0.2, …, 0.9, 1])
    var build_threshold_list = function (steps) {
      var thresholds = [];

      for (var i=1.0; i<=steps; i++) {
        var ratio = i/steps;
        thresholds.push(ratio);
      }

      thresholds.push(0);
      return thresholds;
    };

    // Init all vars ans objects
    var init = function () {
      // Initiate IntersectionObserver
      observer = new IntersectionObserver(update, { threshold: build_threshold_list(100) });

      // Browse all blanks and init vars
      document.querySelectorAll('.js-blank').forEach(function (blank, index) {
        var path = document.getElementById(blank.getAttribute("data-target"));
        var path_length = Math.round(path.getTotalLength());

        path.style.strokeDasharray = path_length;
        path.style.strokeDashoffset = path_length;
        
        observer.observe(blank);

        blanks.push(blank);
        paths.push(path);
        path_lengths.push(path_length);
      });
      
      // Initiate SmootScroll - https://github.com/gblazex/smoothscroll-for-websites/wiki
      // SmoothScroll({
      //   animationTime: 2000,
      //   stepSize: 100,
      //   accelerationDelta: 50,
      //   accelerationMax: 1,
      // });
        
      // Add class to body after init
      document.body.classList.add('is-init');
    };
    
    // Update vars for paths. Trigerred by IntersectionObserver
    var update = function (observables) {
      
      // Browse all element observed 
      observables.forEach(function(o) {
        // If element is in viewport
        if(o.intersectionRatio > 0) {
          var index = parseInt(o.target.getAttribute('data-index')); // Get the index of element
          var current_path = paths[index].style.strokeDashoffset; // Get the current size of path
          var sensitivity = Math.round(path_lengths[index] / 20);

          var new_path = current_path;

          if(
            (scroll_direction > 0 && o.boundingClientRect.top > 0) || // Scrolling Down and intersectionRatio is increasing
            (scroll_direction < 0 && o.boundingClientRect.bottom > o.boundingClientRect.height) // Scrolling Up and intersectionRatio is decreasing
          ) {
            new_path = Math.round(path_lengths[index] + path_lengths[index] * o.intersectionRatio);
          }
          
          var is_leaving_start = (current_path < path_lengths[index] + sensitivity && new_path >= path_lengths[index] + sensitivity);
          var is_leaving_end = (current_path > path_lengths[index] * 2 - sensitivity && new_path <= path_lengths[index] * 2 - sensitivity);
          var is_reaching_start = (current_path > path_lengths[index] + sensitivity && new_path <= path_lengths[index] + sensitivity);
          var is_reaching_end = (current_path < path_lengths[index] * 2 - sensitivity && new_path >= path_lengths[index] * 2 - sensitivity);

          
          if(is_leaving_start || is_leaving_end) {
            update_markers();
          } else if(is_reaching_start) {
            update_markers(index);
            paths[index].style.strokeDashoffset = path_lengths[index] * 2;
          } else if(is_reaching_end) {
            update_markers(index+1);
            paths[index].style.strokeDashoffset = path_lengths[index] * 2;
          }

          paths[index].style.strokeDashoffset = new_path;
        }
      });
    };
    
    var update_markers = function (index) {

      markers.forEach(function(marker) {
        marker.classList.remove('is-active');
      });
      
      if(typeof index !== 'undefined') {
        markers[index].classList.add('is-active');
      }
    };
    
    var vh_unit = function () {
      var $tmp = $('<div></div>').appendTo($('body'));

      $tmp.css({ height: '100vh', width: 0});
      var vhOffset = $tmp.height() - $(window).height();

      $tmp.css({ height: 0, width: '100vw'});
      var vwOffset = $tmp.width() - $(window).width();

      $tmp.remove();

      if(vhOffset > 0){
        $('html').attr('style', '--vh-offset: ' + vhOffset + 'px;');
      }

      if(vwOffset > 0){
        $('html').attr('style', '--vw-offset: ' + vwOffset + 'px;');
      }
    };
    


    /*
     * LISTENERS
     ***********************************/
    

    // Set data attributes on body depending of the scroll direction
    document.addEventListener('scroll', function(event) {
      if(window.scrollY - scroll_tmp > 0) {
        scroll_direction = 1;
      } else {
        scroll_direction = -1;
      }
      document.body.setAttribute('data-scroll-direction', scroll_direction);
      scroll_tmp = window.scrollY;
    });
    
    // Init
    init();
    vh_unit();

  }
});
